import { localeService } from '../services/localeService';

/**
 * Wrapper function that ensures locale is initialized before making API calls
 * This prevents race conditions where API calls are made before country/currency headers are set
 */
export const withLocaleInitialization = async <T>(
  apiCall: () => Promise<T>
): Promise<T> => {
  // Ensure locale is initialized before making any API call
  await localeService.initialize();
  
  // Now make the API call with proper headers
  return apiCall();
};

/**
 * Force refresh locale data and re-initialize if needed
 * This is useful when locale changes and we need to ensure fresh data
 */
export const refreshLocaleData = async (): Promise<void> => {
  // Re-initialize locale service to ensure fresh data
  await localeService.initialize();
}; 